module.exports = __webpack_public_path__ + "img/add.350e8316.svg";